import port1 from '../img/portImages/maya-1.jpg';
import port2 from '../img/portImages/port1.jpg';
import port3 from '../img/portImages/port2.png';
import port4 from '../img/portImages/port3.png';
import port6 from '../img/portImages/port5.png';
import port7 from '../img/portImages/port6.png';
import port8 from '../img/portImages/port8.png';

const portfolios = [
    
    {
        id: 5,
        link1: 'https://dictionary-912dd.web.app/',
        icon1: 'G',
        icon2: 'Y',
        image: port7,
        title: 'Word Hunt',
        paragraph: "A dictionary web application which can show the meaning of any word searched in it in 12 different languages. Built on React.js , it uses Material UI for the styling. Further the website can be toggled into light as well as dark modes."
    },
    {
        id: 2,
        link1: 'https://clone-9aa6c.web.app/',
        icon1: 'G',
        icon2: 'Y',
        image: port2,
        title: 'Amazon Clone',
        paragraph: "This project is a clone of amazon based on react.js where users can add products to their cart and do the checkout of the products. This project has full stripe integration for handling payments. The authentication is being handled by firebase"
    },
     
    {
        id: 4,
        link1: 'https://covid-tracker-cc556.web.app',
        icon1: 'G',
        icon2: 'Y',
        image: port6,
        title: 'Covid-19 Tracker',
        paragraph: "A Covid 19 tracker developed using React.js, Chart.js, Map.js and Material UI . Hosted on firebase, it displays the number of recoveries, deaths and active cases of countries throughout the world using the info given by API of disease.sh"
    },
    
    {
        id: 6,
        link1: 'https://crypto-price-tracker-d1405.web.app/',
        icon1: 'G',
        icon2: 'Y',
        image: port8,
        title: 'Crypto Price Tracker',
        paragraph: "A Crypto price tracker developed using React.js and Material UI . Hosted on firebase, it displays the current market rates and value exchanges of the cryptocurrencies all around the world on the dashboard"
    },
    {
        id: 1,
        link1: "https://arcane-dawn-10895.herokuapp.com/",

        icon1: 'G',
        icon2: 'Y',
        image:  port3,
        title: 'ChatCord',
        paragraph: "An online real time Chat application with frontend based on HTML, CSS, Vanilla Javascript and the backend on Node.js along with Socket.io"
    },
    {
        id: 3,
        link1: 'https://notes-keeper-2e142.web.app/',
        icon1: 'G',
        icon2: 'Y',
        image: port4,
        title: 'Notes Keeper App',
        paragraph: "This is a basic implementation of Google Keep like notes. Built completely on React.js, it supports basic features such as adding, editing and deleting the notes. This project was covered as a part of Angela Yu's Web development course on Udemy"
    },
    
    
    
]

export default portfolios;